import React from 'react';
import DetailsTitle from '../DetailsTitle';
import DetailsField from '../DetailsField';
import { timezoneToLabel } from '../../../../lib/date.utils';

const EventShow = ({ data }) => (
    <React.Fragment>
        <DetailsTitle title={data.name} image={data.image} />
        <div className="ckp-admin-forms-body">
            <div className="ckp-admin-grid-row">
                <div className="ckp-admin-grid-column is-contained is-2-3 u-full-height">
                    <div className="u-margin-bottom-3">
                        <DetailsField field="Organization" value={data.Organization && data.Organization.name} />
                    </div>
                    <div className="u-margin-bottom-3">
                        <DetailsField field="Address" value={data.address1} />
                        <DetailsField field="Address (Cont.)" value={data.address2} />
                        <DetailsField field="Postal Code" value={data.postalCode} />
                        <DetailsField field="City" value={data.city} />
                        <DetailsField field="State / Province" value={data.stateProvince} />
                        <DetailsField field="Country" value={data.country} />
                    </div>
                    <div className="u-margin-bottom-3">
                        <DetailsField field="Timezone" value={timezoneToLabel(data.timeZone)} />
                    </div>
                </div>
            </div>
        </div>
    </React.Fragment>
);

export default EventShow;
